import { cls } from "cls";

export const controlClassNames = cls(
  "bg-white",
  "border-none",
  "text-lime-700",
  "block",
  "cursor-pointer",
  "font-bold",
  "p-3",
  "leading-4",
  "flex-[1_1_33.33%]",
  "h-full",
  "text-[15px]",
);

export const dialogClassNames = cls(
  "h-[82vh]",
  "p-0",
  "mx-0",
  "min-w-full",
  "border-none",
  "shadow-[0_0_10px_rgba(0,0,0,0.4)]",
  "backdrop:bg-black/60",
  "ag-filter",
  "rounded-t",
  "mb-0",
);

// These animations currently pull from keyframes in the filters.less file
export const dialogAnimationClassNames = cls(
  // These animations currently pull from keyframes in the filters.less file
  // Keyframes are used for the slidein animation
  "animate-[slidein_0.25s_ease_normal]",
  "backdrop:animate-[slideinbackdrop_0.25s_ease_normal]",
  // A timeout in src/productListing/ProductListing.tsx along with the transition property is used for the slideout animation
  "transition-[all_0.25s_ease]",
);

export const headerClassNames = cls(
  "bg-white",
  "rounded-t",
  "flex",
  "t-0",
  "absolute",
  "w-full",
  "h-10",
);

export const headingContainerClassNames = cls(
  "flex-[1_1_33.33%]",
  "text-center",
  "flex",
  "justify-center",
  "items-center",
  "flex-col",
);

export const headingClassNames = cls(
  "text-neutral-700",
  "font-bold",
  "leading-4",
  "m-0",
  "text-[15px]",
);

export const spacerClassNames = cls("p-4", "leading-3", "flex-[1_1_33.33%]");
